import CommonIcon from "./CommonIcon";

const AddOptionsFieldIcon = () => {
  return (
    <CommonIcon>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M640-120q-33 0-56.5-23.5T560-200v-160q0-33 23.5-56.5T640-440h160q33 0 56.5 23.5T880-360v160q0 33-23.5 56.5T800-120H640Zm0-80h160v-160H640v160ZM80-240v-80h360v80H80Zm560-280q-33 0-56.5-23.5T560-600v-160q0-33 23.5-56.5T640-840h160q33 0 56.5 23.5T880-760v160q0 33-23.5 56.5T800-520H640Zm0-80h160v-160H640v160ZM80-640v-80h360v80H80Zm640 360Zm0-400Z"
      />
    </CommonIcon>
  );
};

export default AddOptionsFieldIcon;
